<template>
<div>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">  
   
  <div class=" col-md-6 col-12 p-0">

    <div class="col-12 row mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
      <h3><strong>{{msglist[$route.params.language][1]}}</strong></h3><!--KH滴定設定-->
      <div class="ml-auto">
        <router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}">
              <button class="btn btn-primary" style="font-size: 15px; border-radius: 5px;">{{msglist[$route.params.language][0]}}</button><!--KH 設定-->
          </router-link>
       </div>
    </div>
  
    <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
        <div class="col-12 px-0 row mx-0">
            <div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFTklEQVR4nO2dTYgcRRTH/zPvzY6duBqjgQ0a1ChZxC80EEMuKoiGiKCSmwG/USIGMYf1EDwYEUW9CHoxB1FUIip4cP2IAQmoGExQIwaECH4QDRISNWPQmB152KOdt9WzM9PTU91d7w/vMvWq51X9uqq7qqu7AJPJ5EfjzWZzaccATHTxXZD0jf1Pj9MWqd8XzPG/C5X/GQhRjUbjTmZuJ2w6xXWciPYq398bjcaFkkhEW1Tapm7/S0Sbk/5E9CxCVI8Aasz8uvKbIaK1HQcDkCMAZp5SPnLGPpL0MQA5ASCiq5j5mPJ5T5IMQP4AJph5vzrzv3FdYK0FDB8AE9GOtIuuAcgZABE97bjo3px2HGsBQwRARGukwlXX82i342gAsf9paUZET9ltqAMAEe1m5gPqt08A1PsB0K/ZOIC7VlCr2WyebwBG0wW1U87QD2VAZi1gdACOOH5b3ysAInqu0WgsTzOHv01FcKLLYeZVzPymhhJPnM0JwOaCBm8BfxLRdXHyYmY+pNK3u7oiAzA8AO8k05n5Ht0VSR4DMLrJuJqc9crnMIAlSSdrAfkBwNjY2DJmPqr83jYAI3wgw8ybdFdUr9fXddKtBeQMAP9Ozu1Wvgc7jzANwIAiotXMvK1jRPRYmi8zr0j6xrYhTtuY/L1er98yB/jbXMcxmbpqIYDlAduVAFYCWNrFzpIGlsd5tBHA3wDaZuilDr4AsDkGklkyFfybVTwGOfn+ACDPJjgrBCFqZz8GroNtAE7NAuAGx0H3xweuum13lP1bAPsc9gOAv1IgTOvVHP3qDXXAXwGcieorclTmyV385Uy/C8CPjnwPZQlkMYBD6oBbUX1FfQLoaBGAT1W+w1nXod7vCEa6pyorGhAA4pH6Lyrvhqx3RB+rA37XR0ChARBNqbwfIKMudlxonkB1FWUEcJ7K+9MwgnpSHfQYgMtQTUUZAdTj+unkPT6MccG8+LYrGdTOrLdZFQUgOqLyzx9GYKsdgd2H6ikqKgDRawGMDaIiA5hwjA0ESpUUFRmAaH3FxwZR0QHIVf6jjGODSQAXZLDUZYshABBd4hgbPN5H/pajkP3Y0AtUNgCIKzz5J9/3kbdlALJLxgYz6mGEARhhC0AGALsA7M1g0k0g9C4oC4AiywB4lgHwLAPgWQbAswyAZxkAzwoCwKTHuZ65FASAlse5nrlkAGAAepa1gIrOBUXwpyC6oCLLAHiWAfAsA+BZBsCzDIBnGQDPCgLApK0L8gugZctSDEDQXVDLWoBfALtsXZBfAEVW1i7oJFUvR/N8wGQAZmuV4y373GQAZusFBeBF5CgDcKKujd+KTAK4ETnKAPyvmxyf+fky7zdJQwFwUcoXs1YAuBXA+4488sGrq/MONhQA7QHsgVEEG8q6oHYfJq9u3TuqYENZFdHu0eTDHJePMthQAOxLMflcw1sAHgZwqY9gQwFQQ0EVyrqgGgqqUO6CaiiojqtJpypoXpkAHFSBSvBl1xJVJiljYbVHBdt1/6+SaKUq01cosKZVsLP2eymhplSZTti9o2h6sEzB9qidPqYUBtU5KtiZuAmXVdc7LsDnouDaoQKWzTjHUD6Nx2OQZFlkS8XCSz+CE9tS5Fs3hyieUtCt+QqURFsdEF71PKLtVbJl+ruO+F9BiXQKgK8dhZA94dcWtDUQgNvjT9DruPfEXVKpJGOAAymTa/I1LdnB9A4AawBc48nkIns3gOcB/JwSq3xq2LmJaBkke6h8lmE+ve3ZPgdwNkqu+fHZnrazRLuAJrE+U5GplP+0DMDLQ1gH2s7RZBHtS6OeQvkHQ+EbJrXr1G8AAAAASUVORK5CYII="></div>
              <div class="col border-left align-self-center">
              <div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][2]}}</div> <!--KH溶液-->
              <div class="col-12 px-0 row mx-0 align-self-center" style="width:160px">
                <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model=KHRemain maxlength="5" class="col form-control text-center" size="3" name="KHRemain" type="text" value=""> 
                <span class="col-auto px-2 align-self-center">ml</span>
              </div>
              <div class="col-12 px-0 pb-0">{{msglist[$route.params.language][3]}}</div> <!--隨著滴定而減少，顯示剩餘量-->
            </div>
        </div>
		</div>
    	     
    <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
        <div class="col-12 px-0 row mx-0">
            <div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEHElEQVR4nNWaW6hVRRjHf2d/31paWBBpZVdCSKJMC6xMKoWKY3aTwgtdX4zqyUsv9WTQQxlEUHSgwjTK6EbWa/VQkWjaDUJMMy0xSyhLheR0dMfEfx3GzTn7nL33mn32/sPAWjPf/L/5r7Vm5puZBWkxAdgF7NR11+I5oKr0LF2KmcAAcFhpQHldBQe+1ptYBizX9XdARhdhpRr+JWBKW5S3gi7BmcBfwL/A5VH+ZUA/cAiYTBdgnZ786iHKnlHZWjocs4DjwG/AqUOUnwLsk821dCgqwGY98Xvr2N0vm6/UdzoOD6qBG4GeOnah7HPZLqXDcBpwADgGXDkK+ytk+wdwOh2EF/SEX2qgziuq8zwdgks01P4NnNVAvTOAg5rxp9MB+CiawRvFMtUNHGOKG9WQnU2GHpnqBo4bGCOE0WerGrG4BZ4l4ghc9Ua7ZFgSBYJhDmkWPVGAuZA2I/4kekvgu1lcO9odHT8kx5+WyPlZuydJ1/K1WnK8dH00cLQldLlbDjcl4P6ihMFj1Cg65q0JuG8X97epR7D5crStxZFqOPQA38vHPBKi6JAhFE+FB+Qj+EqC6XKwL/EQmclHVcvj0tEn8qdJj9WpIuPxim4D+aVFpruvM7OtZrYqNjazJ5Uf0hwzm1vcA5Ni2zzPLyrKsiwrouBp8hWi43FlCrkjWp7GDd7s7lV3H9xMqFQqi5VXNbMXZbegyAPOjjmyLJtRlLn77KjoG/m8pUwhrw0VqtcKyfN8qrsfkoiNxdNsUsjyFDsue0V6fh0hE8xsm+73A+dEds0IuUA+fy5LREH4U21BLMTd1+v6qLvPqrEbFJLn+cVa4/+f3P26YYQE7JHv8ygBc0X2fh0hv0eNeWcIu0EhI6TZNVU3yPecMoQsFFlfHSFxOubu19QRssfMdhXJ3ffWEdJX5jrlTpG9Xk+Ima0JjdT1dg3ZrfSRgJflewElflqfDCfEzEI4YWY2LxL2VAlCNsh3CPFbxrnR6o2R5hF3f0N5A+4+s0UhO+T7hDqtoIh9LhxJCDDR3Q/orYQoeXyTQqZEsV3aCdHdP3b3P4sZvEClUrkn5CutNLP5xX3tJl6WZdMi26uiohXy+WqZQnpFuqVNWzY9CoeCz5vKJLboe72L9FgkX9tTrN/vE/kPZUekNRgH/ChfYX8gyesuNgfWkA5ro62mZJ/xFB10pjqdfVTcv2rYT4penc6Gc8BVJT21wPGEOP8BrqZNCB3+qJ7euy2eOk0E3hPXYeA22owQNuxXA8Ln9hhwUgP1TwYejz7V3ak2G0b7c8D66MeZg7pfNMxPAZNV9mYk4LgC0hPW8mOFsJD6UMdo1SgdAX5ROlJTFmw/AOLZvGMQ4qhHgLc13/RHDe/XBPcW8HC3/MZBhNBvGuk7TeE/nQBuEwPUgzIAAAAASUVORK5CYII="></div>
              <div class="col border-left align-self-center">
              <div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][7]}}</div><!--每滴定-->
                <div class="col-12 px-0 row mx-0 align-self-center" style="width:160px">
                  <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model=KHdosing maxlength="3" class="col form-control text-center" size="3" name="KHdosing" type="text" value="100"> 
                  <span class="col-auto px-2 align-self-center">ml</span>
                </div>
                <div class="col-12 px-0 pb-0"> {{msglist[$route.params.language][9]}}</div><!--魚缸大小，配方均會影響，請計算輸入--> 
            </div>
        </div>
		</div>      
    
    <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
        <div class="col-12 px-0 row mx-0">
            <div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
              <div class="col border-left align-self-center">
              <div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][10]}}</div><!--每小時最大滴定量:-->
              <div class="col-12 px-0 row mx-0 align-self-center" style="width:160px">
                <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model=maxKHdosingPerHr maxlength="3" class="col form-control text-center" size="3" name="maxKHdosingPerHr" type="text" value="0">
                <span class="col-auto px-2 align-self-center">ml</span>
              </div>
              <div class="col-12 px-0 pb-0">{{msglist[$route.params.language][11]}}</div><!--為了避免滴定過量，請斟酌設定-->
            </div>
        </div>
		</div>

    <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
                <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][4]}}</div><!--校正溶液少於-->
				  				<div class="px-0 row mx-0 align-self-center" style="width:160px">
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model=mlspec maxlength="3" class="col form-control text-center" size="2" name="mlspec" type="text" value="100">
                    <span class="col-auto px-2 align-self-center">ml</span>
                  </div>
                <div class="col-12 px-0 pb-2">{{msglist[$route.params.language][5]}}</div> <!--E-maoil通知-->
		  				</div>
		  		  </div>
		 </div>     
      
    <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center">
                <img style="width:55px;" src="../assets/CRA.png">
              </div>
              <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][15]}}</div><!--配對設備-->
				  			<div class="px-0 row mx-0 align-self-center" style="width:200px">
                  <input  style="height:30px;font-size:1.2rem; font-weight: bold" v-model=PairDev maxlength="12" class="col form-control text-center" size="12" name="PairDev" type="text" value=""></div>			  				
                  <div class="col-auto px-0 pb-2">{{msglist[$route.params.language][16]}}</div>	 <!--若是有選購其他KH/Ca/Mg添加設備，請輸入序號，例如鈣反控制器 序號 CA1-00-00001	-->
                 
              </div>
           </div>
     </div>

    <div class="col-12 row mx-0 px-0 py-3 mb-1 justify-content-center" style="background: rgb(242, 242, 242);">
		  			<button v-if="name!=='khacra'" @click=apply name="KH_settings_button" :disabled="disabled" class="btn btn-primary" style="min-width: 150px;">{{msglist[$route.params.language][12]}}</button> <!--套用-->
    </div>
  </div>
</div>
</template>
<script>
//import Log from 'loglevel';
import has from 'lodash/has';
import {
	mapLang
} from "../routes.js";

const mlist = {
	'en': [
    'My KH',
    'Dosing Setup',
		'KH rising solution',
		'It is reduced after dosing',
		'KH rising & calibration solutions less than',
    'E-mail notify',
    'Notify through E-mail',
    'Amount to increase 1dKH',
    'ml',
    'Tank size and concentration of KH solution determine this value ',
    'Maximum dosing per hour',
    'Input "0" to stop dosing',
    'Apply',
    'Applied',
    'Error',
    'Paired CRA serial',
    'ex. CA1-00-00002',
    'Calibration Solution Setup',  
    'Calibration solution',
    'Solution less than',
    'Calibrate once per',
    'days',
    'KH of calibration solution:',
    'Use 20ml for each calibration. This shows solution remain volume'],
  'vi': [
    'KH Của Tôi',
    'Thiết lập liều lượng',
		'Giải pháp tăng KH',
		'Nó giảm sau khi dùng thuốc',
		'Giải pháp tăng KH & hiệu chuẩn ít hơn',
    'Email thông báo',
    'Thông báo qua E-mail',
    'Số Lượng Cần Tăng 1dKH',
    'ml',
    'Kích thước bể và nồng độ dung dịch KH xác định giá trị này ',
    'Liều tối đa mỗi giờ',
    'Nhập "0" để ngừng dùng thuốc',
    'Áp Dụng',
    'Đã Áp Dụng',
    'Lỗi',
    'Kết Nối CRA ',
    'ex. CA1-00-00002',
    'Thiết lập giải pháp hiệu chuẩn',  
    'Dung dịch hiệu chuẩn',
    'Giải pháp ít hơn',
    'Hiệu chỉnh một lần mỗi',
    'Ngày',
    'KH của dung dịch hiệu chuẩn:',
    'Sử dụng 20ml cho mỗi lần hiệu chuẩn. Điều này cho thấy khối lượng dung dịch vẫn còn'],
  'ms': [
    'My KH',
    'Dosing Setup',
		'KH rising solution',
		'It is reduced after dosing',
		'KH rising & calibration solutions less than',
    'E-mail notify',
    'Notify through E-mail',
    'Amount to increase 1dKH',
    'ml',
    'Tank size and concentration of KH solution determine this value ',
    'Maximum dosing per hour',
    'Input "0" to stop dosing',
    'Apply',
    'Applied',
    'Error',
    'Paired CRA serial',
    'ex. CA1-00-00002',
    'Calibration Solution Setup',  
    'Calibration solution',
    'Solution less than',
    'Calibrate once per',
    'days',
    'KH of calibration solution:',
    'Use 20ml for each calibration. This shows solution remain volume'],
	'tw': [
    '我的KH',
		'滴定設定',
		'KH提升液',
		'隨滴定而減少，顯示剩餘量',
		'KH提升液&校正液少於',
    'E-mail通知',
    '發送E-mail通知',
    '滴幾 ml 可增加 1 dKH',
    ' ml 可增加 1 dKH',
    '魚缸大小，配方均會影響',
    '每小時最大滴定量',
    '輸入0可停止滴定',
    '套用',
    '已套用',
    '錯誤',
    '配對CRA序號',
    '例如:CA1-00-00001',
    'KH校正液設定',  
    'KH校正液',
    '少於幾 ml，E-mail通知',
    '幾天校正一次',
    '天',
    '校正液的KH:',
    '每次校正使用約20ml，此顯示剩餘量'],
	'cn': [
    '我的KH',
		'滴定设定',
		'KH提升液',
		'随滴定而减少，並显示剩馀量',
		'KH提升液&校准液少於',
    'E-mail通知 ',
    '发送E-mail通知',
    '滴几 ml 可增加 1 dKH',
    ' ml 可增加 1 dKH',
    '鱼缸大小，配方浓度均会影响，请计算后输入',
    '每小时最大滴定量',
    '输入0可停止滴定',
    '套用',
    '已套用',
    '错误',
    '配对CRA序号',
    '例如:CA1-00-00001',
    'KH校准液设定',  
    'KH校准液',
    '少于几 ml，E-mail通知',
    '几天校准一次',
    '天',
    '校准液的KH:',
    '每次校准使用约20ml，此显示剩馀量'],
}

let PURL = process.env.SERVER;

function startCfg(Vue) {
    let url = PURL + '/api/v1/KH/start-config';
    let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};  
    let body = {
		"user": user.name,
        "serial": ''
    };

    let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload or change language
    has(user, 'data.devices') ? body.serial = user.data.devices[sidx] : '';
    Vue.serial = body.serial;
    let product = Vue.serial.split('-')[0];

    if (Vue.KHdosing > 999) {Vue.KHdosing=999; } if (Vue.KHdosing < 10) {Vue.KHdosing=10; }
    if (Vue.maxKHdosingPerHr > 999) {Vue.maxKHdosingPerHr=999; } if (Vue.maxKHdosingPerHr < 0) {Vue.maxKHdosingPerHr=0; }
    if (Vue.PairDev.length < 12) {Vue.PairDev ="";}  // old value of field11 = 15; need toset it = "" to prevent website display 15
    body['field11'] = Vue.PairDev;
    body['field12'] = ""+ Number(Vue.CalRemain).toFixed(0);
    body['field14'] = ""+ Number(Vue.KHRemain).toFixed(0);
    body['field16'] = ""+ Number(Vue.mlspec).toFixed(0);
    if (product === 'KH1') {body['field5'] = "" + Number(Vue.KHdosing).toFixed(0); 
                            body['field6'] = "" + Number(Vue.maxKHdosingPerHr).toFixed(0);//KH1: max dosing per hour
                            body['field12'] = "" ;} // not use for KH1
    if (product === 'KH2') {if (Vue.Calday > 60) {Vue.Calday=60; } if (Vue.Calday < 1) {Vue.Calday=1; }
                            if (Vue.CalKH > 9.9) {Vue.CalKH=9.9; } if (Vue.CalKH < 1.0) {Vue.Calday=1.0; } //KH2: KH value of calibration solution
                            
                            body['field5'] = JSON.stringify(Number(Vue.KHdosing) * 1000 + Number(Vue.Calday)); //去除非數字字元
                            body['field6'] = JSON.stringify(Number(Vue.maxKHdosingPerHr) * 10000 + Number(Vue.CalKH)*1000);
                            if (Vue.KHdosing < 100) {body['field5'] = "0" + body['field5'];}  //每個位數不固定，可用此法，第一個位數不足要補"0"
                            if (Vue.KHdosing < 10) {body['field5'] = "0" + body['field5'];}
                            if (Vue.maxKHdosingPerHr < 100) {body['field6'] = "0" + body['field6'];}  //每個位數不固定，可用此法，第一個位數不足要補"0"
                            if (Vue.maxKHdosingPerHr < 10) {body['field6'] = "0" + body['field6'];}
                            if (Vue.maxKHdosingPerHr < 1) {body['field6'] = "0" + body['field6'];}  // allow this ==0
                            }  
                            
    /////// update parameters in localstorage ////////
    if (user.KHdosing) {
      Vue.$set(user.KHdosing, sidx, body['field5']);
      Vue.$set(user.maxKHdosingPerHr, sidx, body['field6']);
      Vue.$set(user.KHRemain, sidx, Math.round(body['field14']) ); // compare in HTML must be number
      Vue.$set(user.CalRemain, sidx, Math.round(body['field12']));
      Vue.$set(user.mlspec, sidx, Math.round(body['field16']));
      Vue.$set(user.PairDev, sidx, body['field11']);
      localStorage.setItem('user', JSON.stringify(user));
    }
    // asynch call
    let p1 = Vue.$http.post(url, body);
    //let p2 = Vue.$http.get(PURL + '/api/v1/KH/' + body.serial + '/pending-config/field3'); // 查詢 pending config 狀態
    //Promise.all([p1, p2]).then(([r1, r2]) => {
    Promise.all([p1]).then(([r1]) => {
        console.log("KH-dosing -- parameters applied");
        Vue.setMsg(mlist[Vue.getLang()][13], 5);
    }, reason => {
      console.log('server error: ', reason);
        Vue.setMsg_logout(mlist[Vue.getLang()][14], 2);
    });
}

function fetchData(Vue) {

  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let body = {
    "user": user.name,
    "password": ''
  };
  if (Vue.$route.params.sidx != null) {localStorage.setItem('sidx', Vue.$route.params.sidx);} // when reload webpage, sidx will be forget and = undefined, null
    let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
	  Vue.serial = user.data.devices[sidx]; // browser use
	  let product = Vue.serial.split('-')[0];
    Vue.name=user.name;
    //localStorage.setItem('pageTimeout', Date.now() + 30 * 1000); // set timeout for this page  
    if (user && user.KHdosing) { // if localstorage user && user.sleep exist, then restore Vue.u parameters from localstorage
      
        //////// get parameters from localstorage /////
        if (product ==='KH1') {Vue.KHdosing = user.KHdosing[sidx]; 
                              Vue.maxKHdosingPerHr = user.maxKHdosingPerHr[sidx];  // KH1: max dosing per hour
                              }
        if (product ==='KH2') {user.KHdosing[sidx]=user.KHdosing[sidx].replace(/[^\d.-]/g, ''); //去除非數字字元
                              user.maxKHdosingPerHr[sidx]=user.maxKHdosingPerHr[sidx].replace(/[^\d.-]/g, ''); //去除非數字字元
                              Vue.KHdosing = Math.floor(user.KHdosing[sidx]/1000); 
                                   Vue.Calday = Math.floor(user.KHdosing[sidx]%1000);
                              Vue.maxKHdosingPerHr = Math.floor(user.maxKHdosingPerHr[sidx]/10000); 
                                   Vue.CalKH = user.maxKHdosingPerHr[sidx]%10000/1000;} // KH2: calibration solution KH value
        
        Vue.KHRemain = Math.round(user.KHRemain[sidx]); if (Vue.KHRemain < 0) {Vue.KHRemain =0;}
        Vue.CalRemain = Math.round(user.CalRemain[sidx]); if (Vue.CalRemain < 0 || Vue.CalRemain == null) {Vue.CalRemain =0;}
        Vue.mlspec = Math.round(user.mlspec[sidx]);
        Vue.PairDev = user.PairDev[sidx]; if (Vue.PairDev.length < 12) {Vue.PairDev ="";}  // old value of field11 = 15; need toset it = "" to prevent website display 15
        console.log("KH-dosing -- get parameters from localstorage");
  } else {  
    
      let urls = PURL + '/api/v1/KH/' + Vue.serial + '/' + 'all_field';
			// asynch call
			let ps = Vue.$http.post(urls, body);
			Promise.all([ps]).then(([rs]) => {
				if ((rs.status === 200 || rs.status === 204)) {
          if (product ==='KH1') {Vue.KHdosing = rs.data['field5']; 
                                 Vue.maxKHdosingPerHr = rs.data['field6'];}  // KH1: max dosing per hour
          if (product ==='KH2') {rs.data['field5']=rs.data['field5'].replace(/[^\d.-]/g, '');rs.data['field6']=rs.data['field6'].replace(/[^\d.-]/g, ''); //去除非數字字元
                             Vue.KHdosing = Math.floor(rs.data['field5']/1000); Vue.Calday = Math.floor(rs.data['field5']%1000);
                             Vue.maxKHdosingPerHr = Math.floor(rs.data['field6']/10000); Vue.CalKH = rs.data['field6']%10000/1000;} // KH2: calibration solution KH value
      
          Vue.KHRemain = Math.round(rs.data['field14']); if (Vue.KHRemain < 0) {Vue.KHRemain =0;}
          Vue.CalRemain = Math.round(rs.data['field12']); if (Vue.CalRemain < 0) {Vue.CalRemain =0;}
          Vue.mlspec = rs.data['field16'];
          Vue.PairDev = rs.data['field11']; if (Vue.PairDev.length < 12) {Vue.PairDev ="";}  // old value of field11 = 15; need toset it = "" to prevent website display 15
					console.log("KH-dosing -- get parameters from server");
				}
			}, reason => {
				console.log('server error: ', reason);
				Vue.setMsg_logout(mlist[Vue.getLang()][14], 2);
      });
      
  }  // if user && user.sleep


}

export default {
  data: () => {
    return {
      disabled: false,
      title: "KH Setting",
      serial:"",
      KHdosing: 350,
      maxKHdosingPerHr: 35,
      Calday: 10,
      CalKH:7.5,
      KHRemain: 1000,
      CalRemain:1000,
      PairDev: "",
      mlspec:100,
      message: "",
      msglist: mlist,
      name: "",
      time_out:"",
      userS: localStorage.getItem('user')
    }
  },
  created: function () {
    // `this` points to the vm instance
	  //fetchData(this);
    //console.log('current KHdosing= ' + this.KHdosing + ', maxKHdosingPerHr=' + this.maxKHdosingPerHr);
  },
  destroyed: function () {
    //console.log('KH-dosing destroy step');
    //clearInterval(this.time_out);
    clearTimeout(this.time_out);
  },
  computed: {
	  alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
    },
    user: () => {
      return this.$store.user
	  },
	  user1: function () {
		return this.$store.getters.user;
	  }

  },
  methods: {
  getLang: function () {
		  if (has(this.$route, "params.language")) {
			  return this.$route.params.language;
		  } else {
			  return mapLang();
		  }
  },
  
  setMsg: function (message, timer) {
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
        }, timer*1000);
    },
  setMsg_logout: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
            ////// to complete logout and show login page need this 3 items
            this.$store.dispatch("setUser", {name: '', token: ''});
            this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
        
    },      
    apply: function () {
      //console.log("this: ", this.$http, startCfg, this.$store.user);
      this.disable();
      startCfg(this);
    },
    disable: function() { this.disabled = true; },
    enable: function() { this.disabled = false; },
	},
  mounted() {
    fetchData(this);
		//localStorage.setItem('pageTimeout', Date.now() + 30 * 1000); // set timeout for this page  
    //let exp=localStorage.getItem('pageTimeout');
		if (this.$auth.loggedIn()) {
    /*  console.log('expiration= ', exp);
      this.pagedosing=setInterval(() => {     // set interval 1 sec to check timeout 
        console.log('exp-date= ', (exp-Date.now())/1000);
        if (Date.now() > parseInt(exp)) {
          //clearInterval(pagedosing);
          this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
        }
      }, 5*1000);  // 1 sec check one times
    */  
    this.time_out=setTimeout( () => {     // return to my-kh after 10 min
      this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
      }, 600*1000);
		} else {
      this.$auth.destroyToken();
			this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
		}
  }
  }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// KH_dosing.vue?08df0d56